import __var_0__ from '@stdlib/utils/define-nonenumerable-read-only-property';
import __var_1__ from './main.js';
import __var_2__ from './object_mode.js';
import __var_3__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Create a readable stream for generating pseudorandom numbers drawn from a Cauchy distribution.
*
* @module @stdlib/random/streams/cauchy
*
* @example
* var inspectStream = require( '@stdlib/streams/node/inspect-sink' );
* var randomStream = require( '@stdlib/random/streams/cauchy' );
*
* function log( chunk ) {
*    console.log( chunk.toString() );
* }
*
* var opts = {
*     'iter': 10
* };
*
* var stream = randomStream( 2.0, 4.0, opts );
*
* stream.pipe( inspectStream( log ) );
*
* @example
* var randomStream = require( '@stdlib/random/streams/cauchy' );
*
* var opts = {
*     'sep': ',',
*     'objectMode': false,
*     'encoding': 'utf8',
*     'highWaterMark': 64
* };
*
* var createStream = randomStream.factory( opts );
*
* // Create 10 identically configured streams...
* var streams = [];
* var i;
* for ( i = 0; i < 10; i++ ) {
*     streams.push( createStream( 2.0, 4.0 ) );
* }
*
* @example
* var inspectStream = require( '@stdlib/streams/node/inspect-sink' );
* var randomStream = require( '@stdlib/random/streams/cauchy' );
*
* function log( v ) {
*    console.log( v );
* }
*
* var opts = {
*     'iter': 10
* };
*
* var stream = randomStream.objectMode( 2.0, 4.0, opts );
*
* stream.pipe( inspectStream.objectMode( log ) );
*/


// MODULES //
var setReadOnly = __var_0__;
var stream = __var_1__;
var objectMode = __var_2__;
var factory = __var_3__;


// MAIN //

setReadOnly( stream, 'objectMode', objectMode );
setReadOnly( stream, 'factory', factory );


// EXPORTS //
export default stream;
